/**
 * Утилиты для работы с сессией и авторизацией
 */

/** Флаг для экрана входа после `handleSessionExpired` (не cookie). */
export const SESSION_EXPIRED_SIGNIN_FLAG = 'webui.sessionExpired'

export function markSessionExpiredForSignin(): void {
  try {
    localStorage.setItem(SESSION_EXPIRED_SIGNIN_FLAG, '1')
  } catch {
    /* private mode / quota */
  }
}

export function consumeSessionExpiredForSignin(): boolean {
  try {
    const flagged = localStorage.getItem(SESSION_EXPIRED_SIGNIN_FLAG) === '1'
    if (flagged) localStorage.removeItem(SESSION_EXPIRED_SIGNIN_FLAG)
    return flagged
  } catch {
    return false
  }
}

export function isSessionExpiredError(error: any): boolean {
  if (!error.response) return false

  const { status, data, headers } = error.response

  if (status === 400) {
    const isSessionError =
      headers['x-session-expired'] === 'true' ||
      (data && (
        data.message?.includes('session') ||
        data.message?.includes('token') ||
        data.message?.includes('auth') ||
        data.error?.includes('session') ||
        data.error?.includes('token') ||
        data.error?.includes('auth')
      ))

    return isSessionError
  }

  if (status === 401) return true
  if (status === 403) return true

  return false
}

export function isNetworkError(error: any): boolean {
  return !error.response && error.request
}

export function isServerError(error: any): boolean {
  return error.response && error.response.status >= 500
}
